import { annotationStudioText } from "./messages";
import type {
  AnnotationOperationAvailability,
  AnnotationSetValidationStatus,
  AnnotationStudioLocale,
  TrackingPreviewTargetMedia,
} from "./types";

export function resolveTrackingPreviewAvailability({
  locale,
  trackingAvailable,
  productAvailability,
  targetMedia,
  hasUnsavedChanges,
  hasPersistedConditioning,
  validationStatus,
  validationAvailability,
  segmentationQueuedOrPending,
  savePending,
  trackingPending,
}: {
  locale: AnnotationStudioLocale;
  trackingAvailable: boolean;
  productAvailability?: AnnotationOperationAvailability;
  targetMedia: TrackingPreviewTargetMedia | null;
  hasUnsavedChanges: boolean;
  hasPersistedConditioning: boolean;
  validationStatus?: AnnotationSetValidationStatus | null;
  validationAvailability?: AnnotationOperationAvailability;
  segmentationQueuedOrPending: boolean;
  savePending: boolean;
  trackingPending: boolean;
}) {
  const validationGateReason =
    validationStatus === "validating"
      ? annotationStudioText("trackingWaitForPendingWork", locale)
      : validationStatus === "error"
        ? annotationStudioText("trackingNeedsConflictCheck", locale)
        : validationAvailability?.allowed === false
          ? (validationAvailability.reason ??
            annotationStudioText("trackingNeedsConflictCheck", locale))
          : null;
  const disabledReason = !trackingAvailable
    ? annotationStudioText("trackingUnavailable", locale)
    : !targetMedia
      ? annotationStudioText("trackingNeedsMediaContext", locale)
      : segmentationQueuedOrPending || savePending
        ? annotationStudioText("trackingWaitForPendingWork", locale)
        : hasUnsavedChanges
          ? annotationStudioText("trackingSaveChangesFirst", locale)
          : !hasPersistedConditioning
            ? annotationStudioText("trackingNeedsSavedAnnotation", locale)
            : validationGateReason
              ? validationGateReason
              : productAvailability?.allowed === false
                ? (productAvailability.reason ??
                  annotationStudioText("trackingUnavailable", locale))
                : trackingPending
                  ? annotationStudioText("trackingRunning", locale)
                  : null;
  const incapableReason = !trackingAvailable
    ? annotationStudioText("trackingUnavailable", locale)
    : !targetMedia
      ? annotationStudioText("trackingNeedsMediaContext", locale)
      : !hasPersistedConditioning
        ? annotationStudioText("trackingNeedsSavedAnnotation", locale)
        : validationGateReason
          ? validationGateReason
          : productAvailability?.allowed === false
            ? (productAvailability.reason ?? annotationStudioText("trackingUnavailable", locale))
            : null;

  return {
    capable: incapableReason === null,
    disabledReason,
    enabled: disabledReason === null,
  };
}
